<template>
  <div>
    <page-title
      heading="Role Manajemen"
      :breadcrumb="[
        {
          label: 'Role Manajemen',
          link: '/role-manajemen',
          active: true
        }
      ]"
    />
    <div class="container-fluid __table-manajemen">
      <b-button
        class="btn btn-primary align-self-end font-weight-bold "
        :to="{
          name: 'role-manajemen-list'
        }"
        style="background-color:#559be2; color:white;border-color:transparent;border-radius:0px"
      >
        User
      </b-button>
      <div class="card card-box mb-3 ninja-shadow mt-3">
        <div class="card-body">
          <div class="col-md-12 no-padding">
            <DataTableWrapper
              :rows="rows"
              :perPage="perPage"
              :currentPage="currentPage"
              :callbackFunc="fetchListManajemen"
              @valueChanged="handleValueChanged"
            >
              <b-table
                striped
                hover
                :items="ManajemenList"
                :fields="fieldList"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                thead-tr-class="izd-datatable-custom"
                :no-local-sorting="true"
              >
                <template v-slot:head()="data">
                  {{ data.label }}
                  <b-input
                    size="sm"
                    class="mt-2 w-95"
                    v-if="data.field.searchable"
                    @input="searchValueChanged($event, data.field.key)"
                  />
                </template>
                <template v-slot:head(id)="data">
                  {{ data.label }}
                </template>

                <template v-slot:cell(id)="data">
                  <b-form-checkbox
                    :name="data.item.email"
                    v-model="checkboxManajemen"
                    :value="data.item.id"
                    class="text-center"
                  ></b-form-checkbox>
                </template>

                <template v-slot:cell(role)="data">
                  <span v-for="(item, index) in data.item.roles" :key="index">
                    <span v-if="index > 0">,</span> {{ item.display_name }}
                  </span>
                </template>

                <template v-slot:cell(status)="data">
                  <template v-if="data.item.status == 2">
                    <div class="text-center status_active">Aktif</div>
                  </template>
                  <template v-else-if="data.item.status == 3">
                    <div class="text-center status_deactive">Non-Aktif</div>
                  </template>
                </template>

                <template v-slot:cell(actions)="data">
                  <center>
                    <font-awesome-icon
                      icon="pencil-alt"
                      style="color:blue;cursor:pointer"
                      @click="editClick(data.item)"
                    />
                  </center>
                </template>
                <template v-slot:cell(last_modified)="data">
                  <label style="font-size:12px;">
                    {{ data.item.updated.at }} <br />
                    by <b>{{ data.item.updated.by }}</b>
                  </label>
                </template>
              </b-table>
            </DataTableWrapper>
          </div>
        </div>
      </div>

      <!-- MODAL -->
      <!-- hide-backdrop -->
      <b-modal
        ref="__modal-role"
        class="__modalll"
        size="md"
        hide-footer
        hide-header
        no-close-on-esc
        no-close-on-backdrop
        content-class="shadow-none"
      >
        <div class="container">
          <div class="row p-2">
            <div class="col-md-12">
              <h4 style="font-weight:650;color:#5486b9">Edit Role</h4>
            </div>
            <div class="col-md-12">
              <b-form @submit.prevent="onSubmit">
                <b-form-group id="input-group-1" label-for="input-1">
                  <label for="" class="label_modal">Nama</label>
                  <b-form-input
                    id="input-1"
                    type="text"
                    :value="formData.nama"
                    disabled
                  ></b-form-input>
                </b-form-group>

                <b-form-group id="input-group-1" label-for="input-1">
                  <label for="" class="label_modal">Email</label>
                  <b-form-input
                    id="input-1"
                    type="text"
                    disabled
                    :value="formData.email"
                    placeholder=""
                  ></b-form-input>
                </b-form-group>

                <b-form-group id="input-group-1" label-for="input-1">
                  <label for="" class="label_modal">No. Handphone</label>
                  <b-form-input
                    id="input-1"
                    type="text"
                    :value="formData.nomor_telp"
                    placeholder=""
                    disabled
                  ></b-form-input>
                </b-form-group>

                <b-form-row>
                  <b-form-group
                    class="col-md-7"
                    id="input-group-1"
                    label-for="input-1"
                  >
                    <label for="" class="label_modal">Role</label>
                    <vue-select
                      multiple
                      :authrole="checkRole"
                      :manajemen="is_manajemen"
                      v-model="selectedRole"
                      :selectable="() => selected.length < 5"
                      :options="optionRole"
                      @input="roleInput($event)"
                    >
                    </vue-select>
                    <span style="color:red">{{ errFormData.roles.desc }}</span>
                  </b-form-group>
                  <b-form-group
                    v-if="!is_owner"
                    class="col-md-5"
                    id="input-group-1"
                    label-for="input-1"
                  >
                    <label for="" class="label_modal">Status</label>
                    <div style="display:flex; margin-top:5px">
                      <b-form-checkbox
                        v-model="checked"
                        switch
                        class="__status-role"
                      >
                      </b-form-checkbox>
                      <label class="ml-0">{{
                        !checked ? "Tidak Aktif" : "Aktif"
                      }}</label>
                    </div>
                    <span style="color:red">{{ errFormData.status.desc }}</span>
                  </b-form-group>
                </b-form-row>

                <b-form-row v-if="isRoleDokter">
                  <b-form-group
                    id="input-group-1"
                    label-for="input-1"
                    class="col-md-12 mb-0"
                  >
                    <strong style="font-size:12px;color:grey;"
                      >Lengkapi data keterangan Dokter</strong
                    >
                  </b-form-group>
                  <b-form-group
                    class="col-md-12"
                    v-if="checkRole == 1 || checkRole == 2"
                  >
                    <label for="" class="label_modal"
                      >Klinik<span style="color:red">*</span></label
                    >
                    <vue-select
                      :disabled="checkRole == 2 && isRoleDokter"
                      multiple
                      v-model="selectedKlinikDokter"
                      :options="optionKlinikDokter"
                      @input="inputKlinikDokter($event)"
                    >
                    </vue-select>
                    <span style="color:red">{{
                      errFormData.selectedKlinikDokter.desc
                    }}</span>
                  </b-form-group>
                  <b-form-group
                    id="input-group-1"
                    label-for="input-1"
                    class="col-md-9"
                  >
                    <label for="" class="label_modal"
                      >SIP <span style="color:red">*</span>
                    </label>
                    <b-form-input
                      id="input-1"
                      type="text"
                      max-length="50"
                      @input="cekSIP($event)"
                      :disabled="
                        (checkRole == 2 && isRoleDokter) ||
                          (checkRole == 1 && selectedKlinikDokter == null)
                      "
                      v-model.trim="formData.sip"
                    ></b-form-input>
                    <span style="color:red">{{ errFormData.sip.desc }}</span>
                  </b-form-group>
                  <b-form-group
                    id="input-group-1"
                    label-for="input-1"
                    class="col-md-5"
                  >
                    <label for="" class="label_modal"
                      >Masa berlaku SIP <span style="color:red">*</span>
                    </label>
                    <DatePickerX
                      :disabled="checkRole == 2 && isRoleDokter"
                      v-model="selectedDate"
                      locale="id"
                      @input="onInputDate($event)"
                    >
                      <template v-slot="{ inputValue, inputEvents }">
                        <b-form-input
                          :value="inputValue"
                          v-on="inputEvents"
                          :disabled="checkRole == 2 && isRoleDokter"
                          :readonly="true"
                          :style="
                            checkRole == 2 && isRoleDokter
                              ? 'background-color:#eeeff8 !important;'
                              : 'background-color:#ffffff !important;'
                          "
                        ></b-form-input>
                      </template>
                    </DatePickerX>
                    <font-awesome-icon
                      icon="calendar"
                      style="
                                float: right !important;
                                position: absolute;
                                right: 15px;
                                top: 44px;
                                color: gray;
                              "
                    />
                    <span style="color:red">{{
                      errFormData.masa_berlaku.desc
                    }}</span>
                  </b-form-group>
                  <b-form-group
                    id="input-group-1"
                    label-for="input-1"
                    class="col-md-7"
                  >
                    <label for="" class="label_modal"
                      >Spesialisasi<span style="color:red">*</span>
                    </label>
                    <v-select
                      v-model="selectedSpesialisasi"
                      :options="optionSpesialisasi"
                      @input="spesialisasiInput($event)"
                      :disabled="checkRole == 2 && isRoleDokter"
                      placeholder="Pilih Spesialisasi"
                      class="__role-manajemen"
                      style="height:auto !important;"
                    />
                    <span style="color:red">{{
                      errFormData.spesialisasi.desc
                    }}</span>
                  </b-form-group>
                </b-form-row>

                <b-form-row v-if="isRolePIC">
                  <b-form-group
                    id="input-group-1"
                    label-for="input-1"
                    class="col-md-12 mb-0"
                  >
                    <strong style="font-size:12px;color:grey;"
                      >Lengkapi data keterangan PIC Faskes</strong
                    >
                  </b-form-group>
                  <b-form-group
                    id="input-group-1"
                    label-for="input-1"
                    class="col-md-6"
                  >
                    <label for="" class="label_modal"
                      >Klinik <span style="color:red">*</span>
                    </label>
                    <v-select
                      v-model="selectedKlinik"
                      :options="optionKlinik"
                      @input="inputKlinik($event)"
                    />
                    <span style="color:red">{{
                      errFormData.nama_klinik.desc
                    }}</span>
                  </b-form-group>
                  <b-form-group
                    id="input-group-1"
                    label-for="input-1"
                    class="col-md-6"
                  >
                    <label for="" class="label_modal"
                      >Kabupaten/Kota<span style="color:red">*</span>
                    </label>
                    <b-form-input
                      id="input-1"
                      type="text"
                      v-model="formData.kab"
                      disabled
                    ></b-form-input>
                  </b-form-group>
                </b-form-row>

                <div class="col-md-8 offset-4 pr-0">
                  <b-button type="submit" variant="primary" class="float-right">
                    Simpan
                  </b-button>
                  <b-button
                    variant="danger"
                    class="float-right mr-3"
                    @click="closeModal()"
                  >
                    Tutup
                  </b-button>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </b-modal>
      <!-- END MODAL -->
    </div>
  </div>
</template>
<script>
import debounce from "lodash/debounce";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCopy,
  faPencilAlt,
  faCalendar,
  faStar
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
moment.locale("id");
import "vue-datetime/dist/vue-datetime.css";
import { mapGetters } from "vuex";
library.add(faCopy, faCalendar, faPencilAlt, faStar);

export default {
  components: {
    DataTableWrapper: () =>
      import("../../components/DataTableWrapperSubkripsi"),
    "vue-select": () => import("@/components/VueSelectMultiple.vue"),
    DatePickerX: () => import("v-calendar/lib/components/date-picker.umd"),
    "v-select": () => import("@/components/VueSelectClearable.vue")
  },
  data() {
    return {
      sortBy: "",
      beingSubmit: false,
      sortDesc: false,
      currentPage: 1,
      rows: 0,
      fromPage: 0,
      toPage: 0,
      checkRole: 0,
      klinik_parent_id: null,
      optionRole: [],
      optionSpesialisasi: [],
      optionKlinik: [],
      perPage: 10,
      ManajemenList: [],
      searchValue: [],
      clickModal: false,
      totalEntries: 0,
      selectedRole: [],
      selectedSpesialisasi: [],
      selectedKlinik: [],
      selectedKlinikDokter: null,
      optionKlinikDokter: [],
      checked: null,
      selectedDate: null,
      isRoleDokter: null,
      isRolePIC: null,
      is_manajemen: null,
      is_owner: null,
      is_pic : null,
      errFormData: {
        nama: {
          error: null,
          desc: null
        },
        email: {
          error: null,
          desc: null
        },
        nomor_telp: {
          error: null,
          desc: null
        },
        roles: {
          error: null,
          desc: null
        },
        status: {
          error: null,
          desc: null
        },
        sip: {
          error: null,
          desc: null
        },
        masa_berlaku: {
          error: null,
          desc: null
        },
        spesialisasi: {
          error: null,
          desc: null
        },
        nama_klinik: {
          error: null,
          desc: null
        },
        kab: {
          error: null,
          desc: null
        },
        selectedKlinikDokter: {
          error: null,
          desc: null
        }
      },
      sipBefore: null,
      user_id : null,
      formData: {
        id_user: null,
        nama: null,
        email: null,
        nomor_telp: null,
        roles: null,
        status: null,
        sip: null,
        masa_berlaku: null,
        spesialisasi: null,
        nama_klinik: null,
        kab: null
      }
    };
  },
  watch: {
    currentPage() {
      this.fetchListManajemen();
    },
    perPage() {
      this.fetchListManajemen();
    },
    sortBy() {
      this.fetchListManajemen();
    },
    sortDesc() {
      this.fetchListManajemen();
    },
    searchValue: {
      handler: "fetchListManajemen",
      deep: true
    }
  },
  computed: {
    ...mapGetters(["getKlinikId"]),
    fieldList() {
      const {
        generateFieldList: g,
        setSearchableAndSortableFieldList: s
      } = this;
      const r = val =>
        Boolean(/(actions|checklist|last_modified)\b/gi.test(val) ? !1 : 1);
      return (
        [
          { key: "nama", label: "Nama" },
          { key: "email", label: "Email" },
          { key: "nomor_telp", label: "No. Handphone", thStyle: "width: 13%" },
          { key: "role", label: "Role", thStyle: "width: 13%" },
          { key: "status", label: "Status", thStyle: "width: 13%" },
          { key: "actions" },
          { key: "last_modified", label: "Last Modified" }
        ]
        |> (v => s({ field: v, customFunc: r }))
        |> (z => g({ field: z }))
      );
    }
  },
  methods: {
    async getKota(val) {
      try {
        const res = await this.$axios.get(`klinik/pic-exists/${val}?id_user=${this.user_id}`);
        const { data, status } = res.data;

        this.formData.kab = data.kota_detail.nama;
        if (!status) {
          this.errFormData.nama_klinik.desc =
            "Klinik telah ditambahkan sebelumnya";
          this.errFormData.nama_klinik.error = true;
        } else {
          this.errFormData.nama_klinik.desc = null;
          this.errFormData.nama_klinik.error = null;
        }
      } catch (error) {}
    },
    async getKlinik() {
      try {
        const res = await this.$axios.get(
          `klinik/dropdown?klinik_id=${this.getKlinikId}`
        );
        const { data, status } = res.data;

        if (status) {
          this.optionKlinik = data.map(val => ({
            ...val,
            label: `${val.nama_klinik}`,
            value: val.id
          }));

          this.optionKlinikDokter = this.optionKlinik;
        }
      } catch (error) {}
    },
    inputKlinik(data) {
      if (this.selectedKlinik != null) {
        this.getKota(data.id);
      }

      if (data == null && this.isRolePIC) {
        this.getKlinik();
        this.formData.nama_klinik = null;
        this.formData.kab = null;

        this.errFormData.nama_klinik.desc = "Kolom harus diisi";
        this.errFormData.nama_klinik.error = true;
      }

      if (this.selectedKlinik.length == 0 || this.selectedKlinik == null) {
        this.errFormData.nama_klinik.desc = "Kolom harus diisi";
        this.errFormData.nama_klinik.error = true;
      } else {
        this.errFormData.nama_klinik.desc = null;
        this.errFormData.nama_klinik.error = null;
      }
    },
    onSubmit() {
      if (this.isRoleDokter == true) {
        if (this.formData.masa_berlaku == null) {
          this.errFormData.masa_berlaku.error = true;
          this.errFormData.masa_berlaku.desc = "Kolom harus diisi";
        }

        if (this.formData.sip == null || this.formData.sip == "") {
          this.errFormData.sip.error = true;
          this.errFormData.sip.desc = "Kolom harus diisi";
        }
        if (this.formData.spesialisasi == null) {
          this.errFormData.spesialisasi.error = true;
          this.errFormData.spesialisasi.desc = "Kolom harus diisi";
        }

        //owner
        if (
          this.checkRole == 1 &&
          (this.selectedKlinikDokter == null || this.selectedKlinikDokter == 0)
        ) {
          this.getKlinik();
          this.errFormData.selectedKlinikDokter.error = true;
          this.errFormData.selectedKlinikDokter.desc = "Kolom harus diisi";
        }
      }

      let err = false;
      Object.entries(this.errFormData).map(function(item, key, index) {
        if (item[1].error == true) {
          err = true;
        }
      });

      if (!err) {
        this.saveDataModal();
      } else {
        this.$swal({
          type: "warning",
          text: "Silakan cek kembali pengisian data Anda!"
        });
      }
    },
    async saveDataModal() {
      try {
        let dokter = false;
        let pic = false;

        this.selectedRole.map(item => {
          if (Boolean(/(dokter_klinik)/gi.test(item.name) ? true : false)) {
            dokter = true;
          }
          if (Boolean(/(pic)/gi.test(item.value) ? true : false)) {
            pic = true;
          }
        });

        const res = await this.$axios.put(
          `role-manajemen/${this.formData.id_user}`,
          {
            id_user: this.formData.id_user,
            klinik_id: this.getKlinikId,
            nama: this.formData.nama,
            email: this.formData.email,
            nomor_telp: this.formData.nomor_telp,
            roles: this.selectedRole,
            status: this.checked ? "2" : "3",
            is_doctor: dokter ? 1 : 0, // = 1 ketika role dokter dipilih, = 0 ketika role dokter tidak dipilih
            nomor_sip: this.formData.sip,
            masa_berlaku_sip: this.selectedDate,
            spesialisasi: {
              id:
                this.selectedSpesialisasi.id == null
                  ? this.selectedSpesialisasi.value
                  : this.selectedSpesialisasi.id,
              nama: this.selectedSpesialisasi.label
            },
            auth_role: this.checkRole,
            klinik_parent_id: this.klinik_parent_id,
            is_pic: pic == true ? 1 : this.is_pic,
            is_manajemen : this.is_manajemen,
            is_owner : this.is_owner,
            klinik_pic:
              this.selectedKlinik.value == null
                ? null
                : this.selectedKlinik.value,
            klinik_dokter:
              this.selectedKlinikDokter == null
                ? null
                : this.selectedKlinikDokter
          }
        );

        if(res.data.status == "failed"){
          this.$swal({
            text: "Anda tidak dapat memilih Role Perawat/Frontdesk",
            type: "warning",
            confirmButtonText: "OK"
          }).then(val => {
              if (val.value) {
                this.tutupModal();
              }
          });
        } else if (res.data.status == false){
          this.$swal({
            text: "Klinik sudah memiliki PIC",
            type: "warning",
            confirmButtonText: "OK"
          }).then(val => {
              if (val.value) {
                this.tutupModal();
              }
          });
        }
         else {
          return setTimeout(() => {
            this.$swal({
              text: "Data berhasil disimpan!",
              type: "success",
              confirmButtonText: "OK"
            }).then(val => {
              if (val.value) {
                this.tutupModal();
              }
            });
          }, 800);
        }

      } catch (error) {}
    },
    onInputDate(data) {
      this.selectedDate = moment(data).format("YYYY-MM-DD");
      this.formData.masa_berlaku = this.selectedDate;

      if (this.selectedDate.length == 0) {
        this.errFormData.masa_berlaku.desc = "Kolom harus diisi";
        this.errFormData.masa_berlaku.error = true;
      } else {
        this.errFormData.masa_berlaku.desc = "";
        this.errFormData.masa_berlaku.error = null;
      }
    },
    spesialisasiInput(data) {
      this.selectedSpesialisasi = data;
      this.formData.spesialisasi = this.selectedSpesialisasi;

      if (this.selectedSpesialisasi == null) {
        this.getSpesialisasi();
        this.errFormData.spesialisasi.desc = "Kolom harus diisi";
        this.errFormData.spesialisasi.error = true;
      } else {
        this.errFormData.spesialisasi.desc = "";
        this.errFormData.spesialisasi.error = null;
      }
    },
    inputKlinikDokter(data) {
      if (this.selectedKlinikDokter == 0) {
        this.errFormData.selectedKlinikDokter.desc = "Kolom harus diisi";
        this.errFormData.selectedKlinikDokter.error = true;
      } else if (this.checkRole == 1 && this.errFormData.sip.error == true) {
        if (
          this.selectedKlinikDokter != null ||
          this.selectedKlinikDokter != 0
        ) {
          this.errFormData.selectedKlinikDokter.desc = "";
          this.errFormData.selectedKlinikDokter.error = null;
        }
        this.cekSIP(this.selectedKlinikDokter);
      } else {
        this.cekSIP(this.selectedKlinikDokter);
        this.errFormData.selectedKlinikDokter.desc = "";
        this.errFormData.selectedKlinikDokter.error = null;
      }
    },
    roleInput(data) {
      let dokter = false;
      let pic = false;

      let dataGroup = data[data.length - 1];

      let newSelected = [];

      this.selectedRole.forEach(element => {
        if (element.group == dataGroup.group) {
          newSelected.push(element);
        }
      });

      this.selectedRole = newSelected;
      this.formData.roles = this.selectedRole;

      //false berarti tidak ada error
      this.selectedRole.map(item => {
        if (dokter == false) {
          dokter = Boolean(/(dokter_klinik)/gi.test(item.value) ? true : false);
        }

        if (pic == false) {
          pic = Boolean(/(pic)/gi.test(item.value) ? true : false);
        }
      });

      if (dokter == true) {
        this.isRoleDokter = true;
        this.getSpesialisasi();

        //owner
        if (
          this.checkRole == 1 &&
          (this.selectedKlinikDokter == null || this.selectedKlinikDokter == 0)
        ) {
          this.getKlinik();
        }
      } else if (dokter == false) {
        this.errFormData.spesialisasi.error = null;
        this.errFormData.spesialisasi.desc = null;

        this.errFormData.sip.error = null;
        this.errFormData.sip.desc = null;

        this.errFormData.masa_berlaku.error = null;
        this.errFormData.masa_berlaku.desc = null;

        this.errFormData.selectedKlinikDokter.error = null;
        this.errFormData.selectedKlinikDokter.desc = null;

        this.isRoleDokter = false;
      }

      if (pic == true) {
        this.isRolePIC = true;
        this.getKlinik();

        if (
          this.isRolePIC == true &&
          (this.selectedKlinik == 0 || this.selectedKlinik == null)
        ) {
          this.errFormData.nama_klinik.error = true;
          this.errFormData.nama_klinik.desc = "Kolom harus diisi";
        }
      } else if (pic == false) {
        this.errFormData.kab.error = null;
        this.errFormData.kab.desc = null;

        this.errFormData.nama_klinik.error = null;
        this.errFormData.nama_klinik.desc = null;

        this.isRolePIC = false;
      }

      if (this.selectedRole == 0) {
        this.errFormData.roles.desc = "Kolom harus diisi";
        this.errFormData.roles.error = true;
      } else {
        this.errFormData.roles.desc = "";
        this.errFormData.roles.error = null;
      }
    },
    async cekSIP(val) {
      if (this._timeoutSIP) clearTimeout(this._timeoutSIP);
      //cek validasi
      if (this.formData.sip.length == 0 || this.formData.sip == "") {
        this.errFormData.sip.error = true;
        this.errFormData.sip.desc = "Kolom harus diisi";
        return;
      } else if (this.formData.sip.match(/[^a-zA-Z0-9-.,/]+/) !== null) {
        this.errFormData.sip.error = true;
        this.errFormData.sip.desc =
          "Hanya bisa huruf, angka, simbol, titik, garis miring, dan -";
        return;
      } else {
        this.errFormData.sip.error = null;
        this.errFormData.sip.desc = "";
      }

      try {
        if (this.selectedKlinikDokter == null && this.checkRole == 1) {
          this._timeoutSIP = setTimeout(() => {
            const res = this.$axios
              .post(`klinik/dokter/sip/cek`, {
                sip: this.formData.sip,
                klinik_id: this.getKlinikId
              })
              .then(res => {
                const { status } = res.data;
                if (this.sipBefore == this.formData.sip) {
                  this.errFormData.sip.error = null;
                  this.errFormData.sip.desc = "";
                } else if (!status) {
                  this.errFormData.sip.error = true;
                  this.errFormData.sip.desc = "SIP telah terdaftar";
                } else {
                  this.errFormData.sip.error = null;
                  this.errFormData.sip.desc = "";
                }
              });
          }, 500);
        } else {
          this._timeoutSIP = setTimeout(() => {
            const res = this.$axios
              .post(`klinik/dokter/sip/cek/multiple`, {
                sip: this.formData.sip,
                kliniks: this.selectedKlinikDokter
              })
              .then(res => {
                const { status, message } = res.data;
                if (this.sipBefore == this.formData.sip) {
                  this.errFormData.sip.error = null;
                  this.errFormData.sip.desc = "";
                } else if (!status) {
                  this.errFormData.sip.error = true;
                  this.errFormData.sip.desc = message;
                } else {
                  this.errFormData.sip.error = null;
                  this.errFormData.sip.desc = "";
                }
              });
          }, 500);
        }
      } catch (error) {}
    },
    async editClick(val) {
      try {
        const res = await this.$axios.get(
          `role-manajemen/${val.user_id}?klinik_id=${this.getKlinikId}`
        );
        const { status, data } = res.data;
        if (status) {
          this.is_owner = data.is_owner;
          this.formData = {
            id_user: data.user_id,
            nama: data.nama,
            email: data.email,
            nomor_telp: data.nomor_telp,
            status: data.status == 2 ? true : false,
            sip: data.nomor_sip == null ? null : data.nomor_sip,
            masa_berlaku:
              data.masa_berlaku_sip == null ? null : data.masa_berlaku_sip,
            spesialisasi:
              data.spesialisasi == null
                ? null
                : {
                    label: data.spesialisasi.nama,
                    value: data.spesialisasi.id
                  },

            nama_klinik: data.kliniks == null ? null : data.kliniks,
            kab: data.kliniks == null ? null : data.kliniks[0].kota_detail.nama
          };

          this.user_id = data.user_id;

          if (this.formData.nama_klinik != null) {
            this.selectedKlinik = {
              label: this.formData.nama_klinik[0].nama_klinik,
              value: this.formData.nama_klinik[0].id
            };
            this.getKlinik();
          }

          this.is_manajemen = data.is_manajemen;
          this.is_pic = data.is_pic;

          //0 bukan pic 1 adalah pic
          this.checkRole = data.auth_role;

          if (data.klinik_dokters != null) {
            this.selectedKlinikDokter = data.klinik_dokters.map(item => ({
              nama_klinik: item.nama_klinik,
              id: item.id,
              label: item.nama_klinik,
              value: item.id
            }));
          }

          this.klinik_parent_id = data.klinik_parent_id;

          //ambil role dari api
          let dataRolenya = data.roles.map(item => {
            if (/(dokter_klinik)/gi.test(item.name)) {
              this.isRoleDokter = true;
              //kalau akun loginya owner trus klik role dokter maka dia bakal generate option klinik
              if (this.isRoleDokter == true && data.auth_role == 1) {
                this.getKlinik();
              }
            }

            if (/(pic)/gi.test(item.name)) {
              this.isRolePIC = true;
            }

            return {
              label: item.display_name,
              value: item.name,
              name: item.name,
              group: item.group
            };
          });

          if (this.formData.spesialisasi != null) {
            this.selectedSpesialisasi = this.formData.spesialisasi;
            this.getSpesialisasi();
          } else if (
            this.isRoleDokter == true &&
            this.formData.spesialisasi == null
          ) {
            this.getSpesialisasi();
            this.errFormData.spesialisasi.error = true;
            this.errFormData.spesialisasi.desc = "Kolom harus diisi";
          }

          if (this.formData.masa_berlaku != null) {
            this.selectedDate = this.formData.masa_berlaku;
          }

          if (this.formData.sip != null) {
            this.sipBefore = this.formData.sip;
          }

          //dimasukin yang terpilih
          this.formData.roles = [...dataRolenya];

          this.selectedRole = this.formData.roles;

          this.$axios
            .get(
              `role/list?id_user=${this.user_id}&auth_role=${this.checkRole}&is_owner=${this.is_owner}`
            )
            .then(respon => {
              this.optionRole = respon.data.data.map(item => ({
                label: item.display_name,
                value: item.name,
                name: item.name,
                group: item.group
              }));
            });

          if (data.status == 2) {
            this.checked = true;
          } else if (data.status == 3) {
            this.checked = false;
          }

          this.$refs["__modal-role"].show();
        }
      } catch (error) {}
    },
    clearData() {
      this.user_id = null;
      this.is_pic = null;
      this.selectedKlinikDokter = null;
      this.optionKlinikDokter = null;
      this.optionRole = null;
      this.optionSpesialisasi = null;
      this.optionKlinik = null;
      this.checkRole = null;
      this.klinik_parent_id = null;
      this.is_owner = null;
      this.checked = null;
      this.isRoleDokter = null;
      this.isRolePIC = null;
      this.selectedRole = null;
      this.selectedDate = null;
      this.sipBefore = null;

      this.formData = {
        nama: null,
        email: null,
        nomor_telp: null,
        roles: null,
        status: null,
        sip: null,
        masa_berlaku: null,
        spesialisasi: null,
        nama_klinik: null,
        kab: null
      };

      this.errFormData = {
        nama: {
          error: null,
          desc: null
        },
        email: {
          error: null,
          desc: null
        },
        nomor_telp: {
          error: null,
          desc: null
        },
        roles: {
          error: null,
          desc: null
        },
        status: {
          error: null,
          desc: null
        },
        sip: {
          error: null,
          desc: null
        },
        masa_berlaku: {
          error: null,
          desc: null
        },
        spesialisasi: {
          error: null,
          desc: null
        },
        nama_klinik: {
          error: null,
          desc: null
        },
        kab: {
          error: null,
          desc: null
        },
        selectedKlinikDokter: {
          error: null,
          desc: null
        }
      };

      this.selected = [];
      this.selectedSpesialisasi = [];
      this.selectedKlinik = [];
    },
    closeModal() {
      this.$swal({
        text: `Anda yakin untuk keluar dari halaman ini?`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Tidak",
        confirmButtonText: "Ya",
        confirmButtonColor: "#1791EE"
      }).then(res => {
        if (res.value) {
          this.tutupModal();
        }
      });
    },
    tutupModal() {
      this.clearData();
      this.$router.go('/role-manajemen');
      this.$refs["__modal-role"].hide();
    },
    handleValueChanged({ perPage, currentPage }) {
      perPage && (perPage |> (_ => (this.perPage = _)));
      currentPage && (currentPage |> (_ => (this.currentPage = _)));
    },
    searchValueChanged: debounce(function(val, key) {
      const { searchValue } = this;
      const z = searchValue.filter(item => item.key !== key);
      this.searchValue = [
        ...z,
        {
          key,
          value: val
        }
      ];
    }, 500),
    determineParameter() {
      const { searchValue, sortBy, sortDesc } = this;
      let v = "";

      searchValue.map(item => {
        const x = item.key;
        v += `&${x}=${item.value}`;
      });

      if (sortBy) {
        v += `&column=${sortBy}&order=${sortDesc ? "desc" : "asc"}`;
      }

      return v;
    },
    getSpesialisasi() {
      this.$axios
        .get(`spesialisasi`)
        .then(response => {
          this.optionSpesialisasi = response.data.data.spesialisasi.map(
            val => ({
              ...val,
              label: `${val.nama}`
            })
          );
        })
        .catch(error => {
          // handle error
          // console.log(error);
        });
    },
    async fetchListManajemen() {
      try {
        const res = await this.$axios.get(
          `role-manajemen?klinik_id=${this.getKlinikId}&limit=${
            this.perPage
          }&page=${this.currentPage}${this.determineParameter()}`
        );
        const { status, data } = res.data;

        if (status) {
          const {
            data: listData,
            total: totalEntries,
            to: toPage,
            from: fromPage
          } = data;

          this.totalEntries = totalEntries;
          this.toPage = toPage;
          this.fromPage = fromPage;
          this.rows = totalEntries;

          this.ManajemenList = [
            ...listData.map((item, index) => {
              return {
                ...item,
                no: (this.currentPage - 1) * this.perPage + index + 1,

                updated: {
                  at: moment(item.updated.at).format("MMM DD, YYYY @ HH:mm"),
                  by: item.updated.by || "anonim"
                }
              };
            })
          ];
          return this;
        }
      } catch (err) {
        // console.log(err);
      }
    }
  }
};
</script>

<style scoped></style>

<style lang="scss">
.modal-backdrop {
  opacity: 0.5 !important;
}

.__status-role .custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #29e178;
  background-color: #29e178;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: #e6eef6 !important;
}

.izd-datatable-custom {
  th {
    vertical-align: top !important;
  }
}

td {
  &.tarif-pre-whitespace {
    text-align: right !important;
    white-space: pre;
    padding-right: 2rem;
  }
}

.izd-datatable-custom th {
  text-transform: uppercase;
  background-color: white !important;
  color: #5486b9 !important;
  font-size: 0.83125rem;
}

.izd-datatable-custom th,
.izd-datatable-custom td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid transparent !important;
}
</style>

<style scoped lang="scss">
.label_modal {
  font-size: 16px;
  color: #5486b9;
  font-weight: 700;
}

.__table-manajemen {
  zoom: 85%;
}

.bg-kuning {
  background: #f7fc6b;
}

.bg-kuning,
.bg-danger,
.bg-first {
  color: black !important;
}

.no-padding {
  padding: 0 !important;
}

.page-item.active a {
  background: #3b86ff;
  border: none !important;
}

.ninja-shadow {
  box-shadow: 0px 8px 15px 0px lightgrey;
}

.status_active {
  width: 100%;
  border-radius: 8px;
  font-size: 12px;
  font-weight: bold;
  padding: 7px;
  color: #67cc6f;
  background-color: #c3fad6;
}

.status_deactive {
  width: 100%;
  border-radius: 8px;
  font-size: 12px;
  font-weight: bold;
  padding: 7px;
  color: #f57380;
  background-color: #f8cccf;
}

.status_waiting {
  width: 100%;
  border-radius: 8px;
  font-size: 12px;
  font-weight: bold;
  padding: 7px;
  color: #a7a5ef;
  background-color: #f3f7fb;
}
</style>
